module.exports = __webpack_public_path__ + "static/media/three_dots.76c20cb1.svg";